import { isAndroid, isIOS } from '@/utils';

/**
 * 设置与原生应用的通信
 */
function setupCommunication() {
  if (isAndroid) {
    /**
     * 连接 WebView Javascript Bridge
     * @param callback 回调函数
     */
    function connectWebViewJavascriptBridge(callback) {
      try {
        if (window.WebViewJavascriptBridge && WebViewJavascriptBridge.inited) {
          callback(WebViewJavascriptBridge);
        } else {
          document.addEventListener(
            'WebViewJavascriptBridgeReady',
            function () {
              callback(WebViewJavascriptBridge);
            },
            false,
          );
        }
      } catch (e) {
        callback(null);
      }
    }

    connectWebViewJavascriptBridge(function (bridge) {
      if (!bridge) return;

      bridge.init(function (message, responseCallback) {
        console.log('JS got a message', message);
        const data = {
          'Javascript Responds': 'test',
        };

        if (responseCallback) {
          console.log('JS responding with', data);
          responseCallback(data);
        }
      });
      window.bridge = bridge;
    });
  }

  if (isIOS) {
    /**
     * 设置 WKWebView Javascript Bridge
     * @param callback 回调函数
     */
    function setupWKWebViewJavascriptBridge(callback) {
      try {
        if (window.WKWebViewJavascriptBridge) {
          return callback(WKWebViewJavascriptBridge);
        }
        if (window.WKWVJBCallbacks) {
          return window.WKWVJBCallbacks.push(callback);
        }
        window.WKWVJBCallbacks = [callback];
        window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null);
      } catch (e) {
        callback(null);
      }
    }

    setupWKWebViewJavascriptBridge(function (bridge) {
      window.bridge = bridge;
    });
  }
}

setupCommunication();
